import type { CSSProperties, ReactNode } from "react";

export enum CsegmentedpanelVariant {
  Seamed = "Seamed",
  InsetCells = "Inset cells",
  SignalRails = "Signal rails",
  LabelBands = "Label bands",
}

export enum CsegmentedpanelTone {
  Positive = "positive",
  Negative = "negative",
  Caution = "caution",
  Neutral = "neutral",
  Muted = "muted",
}

export interface CsegmentedpanelItemData {
  readonly label: string;
  readonly value: ReactNode;
  readonly tone?: CsegmentedpanelTone;
}

export interface CsegmentedpanelProps {
  readonly items: readonly CsegmentedpanelItemData[];
  readonly columns?: number;
  readonly variant?: CsegmentedpanelVariant;
  readonly style?: CSSProperties;
}

export interface CsegmentedpanelVariantProps {
  readonly items: readonly CsegmentedpanelItemData[];
  readonly columns: number;
  readonly style?: CSSProperties;
}

export interface CsegmentedpanelPresentation {
  readonly container: CSSProperties;
  readonly cell: CSSProperties;
  readonly label: CSSProperties;
  readonly value: CSSProperties;
  readonly hasToneRail: boolean;
}
